<template>
	<div class="hdl-create-workspace">
		<div class="hdl-auth-container mb-4">
			<div class="text-center text-3xl mb-5">
				<font-awesome-icon :icon="['fas', 'circle-check']" />
			</div>
			<div class="hdl-heading-secondary text-center mb-4">
				Create a workspace
			</div>
			<div class="text-center mb-5 text-lg">
				This is where you'll create and analyze surveys.
			</div>
			<div class="mb-8">
				<div class="mb-1 text-lg font-semibold">Name</div>
				<hdl-textbox
					v-model="workspaceName"
					hdl-style="auth"
					class="w-full"
					focus-on-mount
					@enter="createWorkspace"
				/>
			</div>
			<div class="mb-8">
				<div class="mb-1 text-lg font-semibold">Plan</div>
				<plan-selector v-model="selectedPlan" />
			</div>
			<div class="">
				<hdl-button
					@click.prevent="createWorkspace"
					:is-loading="creatingWorkspace"
					label="Create workspace"
					hdl-style="primary"
					size="lg"
					class="w-full"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FetchResult, fetcher } from '@/common/fetcher';
import PlanSelector from '../components/PlanSelector.vue';

library.add(faCircleCheck);

declare type ValidationType = 'notvalidated' | 'validated' | 'invalid';

@Component({
	components: {
		PlanSelector
	}
})
export default class CreateWorkspacePage extends Vue {
	workspaceName: string = '';

	creatingWorkspace: boolean = false;

	selectedPlan: 'free' | 'pro' = 'free';

	created(): void {
		if (this.$route.query) {
			if (this.$route.query.plan && ['free', 'pro'].includes(this.$route.query.plan as string)) {
				this.selectedPlan = this.$route.query.plan as 'free' | 'pro';
			}
		}
	}

	createWorkspace(): void {
		this.creatingWorkspace = true;
		fetcher.Post(
			'/account/workspaces/create/',
			{
				workspaceName: this.workspaceName,
				plan: this.selectedPlan
			}
		).then(
			(result: FetchResult) => {
				if (result.response.ok && result.json.success) {
					window.location.assign(
						result.json.data.redirectTo
					);
				}
				this.creatingWorkspace = false;
			}
		)
	}
}
</script>

<style lang="scss">

</style>
